import { Component, OnInit, Input } from '@angular/core';
import { getDatabase, ref as refDatabase, get, child} from "firebase/database";
import { Post, PostField, Template } from "../container"
import { Router } from '@angular/router';
import { DatabaseService } from '../database.service';
import { FirestoreService } from '../firestore-service.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-linkednotes',
    templateUrl: './linkednotes.component.html',
    styleUrls: ['./linkednotes.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule]
})
export class LinkednotesComponent implements OnInit {
  @Input()organizationKey: string = "";
  @Input()projectKey: string = "";
  @Input()postKey: string = "";
  @Input()fieldKey: string = "";
  @Input()posts: Post[] = [];
  @Input()templates: Template[] = [];
 
  constructor(private router: Router, private databaseService: DatabaseService, private firestoreService: FirestoreService) { }

  ngOnInit(): void {
  }

  showPost(postKey: string) {
    this.router.navigate(["post/"+this.organizationKey+"/"+this.projectKey+"/"+postKey])
  }

  getPosts(projectKey: string, projectName: string, all: boolean = false) {
    const db = getDatabase();
    const mapRef = refDatabase(db, "/");
    get(child(mapRef, "organizations/"+this.organizationKey+"/projects/"+projectKey+"/lessonslearned/")).then((snapshot) => {
      if (all == false) { // do not remove posts array if collecting posts from all projects
        this.posts.splice(0, this.posts.length);
      }

      if (snapshot.exists()) {
        snapshot.forEach((child) => {
          let title: any = child.child("/title").val()
          let dateOfCreation: any = child.child("/dateOfCreation").val()
          let authorKey: any = child.child("/authorKey").val()
          let authorName: any = child.child("/authorName").val()
          let dateOfUpdate: any = child.child("/dateOfUpdate").val()
          let nameHTML: any = child.child("/nameHTML").val()
          let tags: any = child.child("/tags").val()
          let projectKey: any = child.child("/projectKey").val()
          let postKey: any = child.key;
          let date = new Date(dateOfCreation)
          let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
          let formattedDate = date.toLocaleDateString("pl-PL");
          let lastCommentDate = new Date(child.child("/lastCommentDate").val())
          let commentCount: number = child.child("/commentCount").val()
          let categoryKey: any = child.child("/categoryKey").val()
          let viewCount: any = child.child("/viewCount").val()
          let contentRowsCount: any = child.child("/rowsCount").val()
          let name: any = child.child("/name").val()
          let isDeleted: any = child.child("/isDeleted").val()
          let coverImageURL: any = child.child("/coverImageURL").val()
          let isDownloadAvailable: any = child.child("/isDownloadAvailable").val()
          let templateKey: any = child.child("/templateKey").val()
          let contentType: any = child.child("/contentType").val()
          const embedding = child.child("/embedding").val()
          let progressPercent: any = child.child("/progressPercent").val() || 0
          let snapshotFields = child.child("/fields")
          let fields: PostField[] = []
          let startDate: any = child.child("/startDate").val()
          let endDate: any = child.child("/endDate").val()
          let manHours: any = child.child("/manHours").val()
          let isSelected: any = child.child("/isSelected").val() || false
          let fileType: any = child.child("/type").val() || ""
          if (snapshotFields.exists()) {
            snapshotFields.forEach((childField) => {
              let contentField = childField.child("/content").val()
              let sequenceField = childField.child("/sequence").val()
              let typeField = childField.child("/type").val()
              let keyField = childField.child("/key").val()
              let noteType = childField.child("/noteType").val()
              const uid = childField.child("/uid").val() || this.firestoreService.generateUID()
              const date = childField.child("/date").val() || ""
              const label = childField.child("/label").val() || ""
              fields.push({"key": keyField, "content": contentField, "placeholder": "", "sequence": sequenceField, "type": typeField, "noteType": noteType, "links": [], "uid": uid, "date": date, "isExpanded": false, "label": label}) // TU POWINIEN ODCZYTYWAC LINKI DO INNUYCH POSTOW!!!
            })
          }
          if (templateKey == undefined) {
            templateKey = "note"
          }
          if (isDownloadAvailable == undefined) {
            isDownloadAvailable = false
          }
          if (isDeleted != "true") {
            let colorField = this.getTemplateColor(templateKey)
            const templateName = this.templates.find(t => t.key == templateKey)?.name || ""
            this.posts.push({"title": title, "key": postKey, "dateOfCreation": date, "dateOfUpdate": dateOfUpdate, "formattedDate": formattedDate, "authorKey": authorKey, "authorName": authorName, "nameHTML": nameHTML, "imageURLs": [], "coverImageURL": coverImageURL, "commentCount": commentCount, "viewCount": viewCount, "lastCommentDate": lastCommentDate, "categoryKey": categoryKey, "name": name, "contentRowsCount": contentRowsCount, "organizationKey": this.organizationKey, "projectKey": projectKey, "isNewPost": false, "isDeleted": false, "loggedUserDisplayName": "", "loggedUserKey": "", "isDownloadAvailable": isDownloadAvailable, "projectName": projectName, "templateKey": templateKey, "color": colorField, "fields": fields, "tags": [], "contentType": contentType, "embedding": embedding, "isRead": false, "isTop": false, "isFavourite": false, "progressPercent": progressPercent, "startDate": startDate, "endDate": endDate, "manHours": manHours, "isSelected": isSelected, "templateName": templateName, "isCompleted": false, "parentName": "", "areKidsColored": false, "description": "", "assignedUsers": [], "status": "", "sequence": 0, "parentKey": "", "isExpanded": false, "areKidsTagged": false, "milestoneKey": "", "isChecked": false, "isParent": false, "fileType": fileType}) // TU JEST BLAD BO MUSI ODCZYRTYWAC ZAWARTOSC POL!!!
          }
        });
  
        this.posts.sort(function (a, b) {
          return b.dateOfCreation.getTime() - a.dateOfCreation.getTime();
        })
      }
    })
  }

  getTemplateColor(templateKey: string) {
    for (let i = 0; i < this.templates.length; i++) {
      if (this.templates[i].key == templateKey) {
        return this.templates[i].color
      }
    }
    return "#ffffff"
  }

  removeLink(linkedPostKey: string) {
    this.databaseService.removeLinkedPost(this.organizationKey, this.projectKey, this.postKey, this.fieldKey, linkedPostKey)
    this.firestoreService.showSnackBar("Powiązanie z notatką zostało usunięte.")
    let i = this.getLinkedPostIndex(linkedPostKey)
    this.posts.splice(i,1)
  }

  getLinkedPostIndex(postKey: string) {
    for (let i = 0; i<this.posts.length; i++) {
      if (this.posts[i].key == postKey) {
        return i
      }
    }
    return -1
  }

}
